import stripeLogo from './assets/stripe.svg';
export function Footer() {
	return (
		<>
			<ul className="wp-checkout-footer-list">
				<li className="wp-checkout-footer-list-item">
					<span>Powered by</span>
					<div className="footer-content-logo">
						<img
							src={stripeLogo}
							alt=""
						/>
					</div>
				</li>

				<li className="wp-checkout-footer-list-item">
					{' '}
					<a href="#">Terms</a>
				</li>
				<li className="wp-checkout-footer-list-item">
					<a href="#">Privacy</a>
				</li>
				<li className="wp-checkout-footer-list-item">
					<a href="#">Contact</a>
				</li>
			</ul>
		</>
	);
}
